import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

const LogoutPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const performLogout = async () => {
      // Clear local storage
      localStorage.removeItem("token");
      localStorage.removeItem("userId");

      // Redirect after short delay
      setTimeout(() => {
        navigate("/signin");
      }, 1500);
    };

    performLogout();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="p-6 bg-red-600 rounded-full inline-block mb-6 animate-pulse">
          <LogOut className="w-12 h-12 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">à¸à¸³à¸¥à¸±à¸‡à¸­à¸­à¸à¸ˆà¸²à¸à¸£à¸°à¸šà¸š...</h2>
        <p className="text-gray-300">à¸à¸£à¸¸à¸“à¸²à¸£à¸­à¸ªà¸±à¸à¸„à¸£à¸¹à¹ˆ</p>
        <div className="mt-6 w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin mx-auto" />
      </div>
    </div>
  );
};

export default LogoutPage;
